import { useMutation } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { MutationOptions } from '@/api/react-query'
import { userPathKey } from '@/helpers'
import { UpsertUserProfileBody } from '@/types'

export async function upsertUserProfile(body: UpsertUserProfileBody) {
  const response = await httpClient('user-manager').put(
    `/v1/user/${userPathKey()}/profile`,
    body,
  )

  return response.data
}

export function useUpsertUserProfile(
  options?: MutationOptions<unknown, UpsertUserProfileBody>,
) {
  return useMutation({
    mutationFn: upsertUserProfile,
    ...options,
  })
}
